import { state } from './state';
import getters from './getters';

const brands = {
  state,
  getters,
};

export default brands;
